import { SimpleRenderer } from "../renderer/simple-renderer";
import { Layer } from "./layer";
/**
 * 矢量图层类
 */
export class FeatureLayer extends Layer {
    constructor() {
        super(...arguments);
        /**
         * 图层渲染方式
         */
        this._renderer = new SimpleRenderer();
        /**
         * 是否显示标注
         */
        this.labeled = false;
    }
    /**
     * 获取矢量要素类（数据源）
     */
    get featureClass() {
        return this._featureClass;
    }
    /**
     * 设置矢量要素类（数据源）
     */
    set featureClass(value) {
        this._featureClass = value;
    }
    /**
     * 获取图层标注
     */
    get label() {
        return this._label;
    }
    /**
     * 设置图层标注
     */
    set label(value) {
        this._label = value;
    }
    /**
     * 获取图层渲染方式
     */
    get renderer() {
        return this._renderer;
    }
    /**
     * 设置图层渲染方式
     */
    set renderer(value) {
        this._renderer = value;
    }
    /**
     * 设置图层显示坐标系
     */
    set crs(value) {
        this._crs = value;
        let feature = this._featureClass.first;
        while (feature) {
            feature.geometry.crs = value;
            feature = feature.next;
        }
    }
    /**
     * 数据变换
     * @param {ScreenXY} origin - 窗口坐标原点
     * @param {number} zoom - 当前缩放级别
     */
    transform(origin, zoom) {
        this._origin = origin;
        this._zoom = zoom;
        let feature = this._featureClass.first;
        while (feature) {
            feature.geometry.transform(origin, zoom, this._renderer.getSymbol(feature));
            feature = feature.next;
        }
    }
    /**
     * 绘制图层
     * @remarks
     * 遍历图形集合进行绘制
     * @param {CanvasRenderingContext2D} ctx - 绘图上下文
     * @param {number} zoom - 当前缩放级别
     * @param {ScreenBounds} redrawBounds - 当前可视范围
     */
    draw(ctx, zoom, redrawBounds) {
        if (!this.visible || this.minZoom > zoom || this.maxZoom < zoom)
            return;
        // before draw
        this._renderer.init(redrawBounds);
        let feature = this._featureClass.first;
        // let count = 0;
        const features = [];
        while (feature) {
            if (feature.visible) {
                if (!redrawBounds || (feature.geometry && feature.geometry.screenBounds && feature.geometry.screenBounds.intersects(redrawBounds))) {
                    const symbol = this._renderer.getSymbol(feature);
                    if (symbol) {
                        feature.draw(ctx, symbol);
                        features.push(feature);
                    }
                    // count += 1;
                }
            }
            feature = feature.next;
        }
        // console.log(count);
        if (this.labeled) {
            this.label.draw(ctx, features);
        }
    }
    /**
     * 根据当前屏幕坐标位置查询图层
     * @param {ScreenXY} screenXY - 当前屏幕坐标位置
     * @param {number} zoom - 当前缩放级别
     * @param {ScreenBounds} redrawBounds - 当前可视范围
     */
    query(screenXY, zoom, bounds) {
        if (!this.visible || this.minZoom > zoom || this.maxZoom < zoom)
            return [];
        let feature = this._featureClass.first;
        const features = [];
        while (feature) {
            if (feature.geometry && feature.geometry.screenBounds && feature.geometry.screenBounds.intersects(bounds)) {
                if (feature.geometry.contains(screenXY)) {
                    features.push(feature);
                }
            }
            feature = feature.next;
        }
        return features;
    }
    on(types, fn, context) {
        let feature = this._featureClass.first;
        while (feature) {
            feature.on(types, fn, context);
            feature = feature.next;
        }
        return this;
    }
    addFeature(feature) {
        if (this._crs)
            feature.geometry.crs = this._crs;
        if (this._origin)
            feature.geometry.transform(this._origin, this._zoom, this._renderer.getSymbol(feature));
        this._featureClass.addFeature(feature);
    }
    removeFeature(feature) {
        this._featureClass.removeFeature(feature);
    }
    clearFeatures() {
        this._featureClass.clearFeatures();
    }
}
